<script setup>
const props = defineProps({
  suggestion: { type: Object, required: true },
  triggerId: { type: String, required: true },
  ariaLabel: { type: String, required: true },
})

const emit = defineEmits(["apply", "dismiss"])
</script>

<template>
  <div class="dropdown ai-suggestion-dropdown">
    <button
      type="button"
      class="btn btn-sm p-0 ai-suggestion-trigger"
      :id="triggerId"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      :aria-label="ariaLabel"
    >
      <span class="fa fa-atom turboguide-gradient-icon" aria-hidden="true"></span>
    </button>

    <ul
      :aria-labelledby="triggerId"
      class="dropdown-menu dropdown-menu-end shadow-sm p-0 ai-suggestion-dropdown__menu"
    >
      <li class="px-3 py-2">
        <strong class="small text-primary d-block mb-2">
          <span class="fa fa-atom me-1 turboguide-gradient-icon" aria-hidden="true"></span>
          AI Suggestion
        </strong>
        <p class="small mb-3 ai-suggestion-dropdown__text">{{ suggestion.suggestedText }}</p>
        <div class="d-flex gap-2">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click.prevent="emit('apply', suggestion)"
          >
            Apply
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click.prevent="emit('dismiss', suggestion)"
          >
            Dismiss
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>